import { getValidDateType } from '@/pages/intelligence/utils/commonUtils';
import { handleRangeDate2SingleDateRangeTimeFilterExtend } from '@intelligence/utils/dateUtils';
import {
  // 日期筛选器
  DATE_PICKER as RANGE_TIME_SELECT_FILTER,
  // 组合国家筛选器
  COMPOSED_COUNTRY_SELECT as COMPOSED_COUNTRY_SELECT_FILTER,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';

import type { IDateType } from '@/pages/intelligence/types/common';

export const getInitialFormValue = (
  isOperate: boolean,
  filterExtend: any,
  defaultFormValue: any,
  cfg: { typeList: IDateType[] },
) => {
  // 没有操作过筛选器，不继承
  if (!isOperate) return defaultFormValue ?? {};

  const { typeList } = cfg || {};
  const typeListTmp = Array.isArray(typeList) && typeList.length ? typeList : ['date'];

  const filterExtendTmp = handleRangeDate2SingleDateRangeTimeFilterExtend(filterExtend);

  /** 各个筛选器的继承值 **/
  const rangeTimeFilterExtend = filterExtendTmp?.[RANGE_TIME_SELECT_FILTER];
  const composedCountrySelectFilterExtend = filterExtendTmp?.[COMPOSED_COUNTRY_SELECT_FILTER]?.value;
  /** 各个筛选器的继承值 **/

  /** 各个筛选器的默认值 **/
  const rangeTimeDefault = defaultFormValue?.[RANGE_TIME_SELECT_FILTER];
  const composedCountryDefault = defaultFormValue?.[COMPOSED_COUNTRY_SELECT_FILTER]?.value;
  /** 各个筛选器的默认值 **/

  const dateTypeTmp = rangeTimeFilterExtend?.filterType ?? rangeTimeDefault?.type;
  const dateValueTmp = rangeTimeFilterExtend?.filterValue ?? rangeTimeDefault?.value;
  const startDateValueTmp = dateValueTmp?.[0];
  const initialDateType = getValidDateType(dateTypeTmp, typeListTmp);
  const initialDateValue = initialDateType === 'week' ? dateValueTmp : [startDateValueTmp, startDateValueTmp];

  return {
    // 日期筛选器
    [RANGE_TIME_SELECT_FILTER]: {
      type: initialDateType,
      value: initialDateValue,
    },
    // 组合国家筛选器
    [COMPOSED_COUNTRY_SELECT_FILTER]: {
      value: {
        type: 'single',
        countries:
          composedCountrySelectFilterExtend?.countries?.length === 1
            ? composedCountrySelectFilterExtend?.countries
            : composedCountryDefault?.countries,
      },
    },
  };
};

export const getInitialInputList = (
  inputList: any[],
  cfg: { typeList: IDateType[]; composedCountryVisible?: boolean },
) => {
  if (!Array.isArray(inputList)) return [];
  const { typeList, composedCountryVisible = true } = cfg || {};
  const inputListTmp = [...inputList];
  const typeListTmp = Array.isArray(typeList) && typeList.length ? typeList : ['date'];
  const rangeTimeFilterTmp = inputListTmp.find((item) => item?.type === RANGE_TIME_SELECT_FILTER);
  if (rangeTimeFilterTmp) {
    rangeTimeFilterTmp.showSelectType = typeListTmp?.length > 1;
    rangeTimeFilterTmp.typeList = typeListTmp;
  }

  const composedCountryFilterTmp = inputListTmp.find(
    (item) => item?.key === COMPOSED_COUNTRY_SELECT_FILTER,
  );
  if (composedCountryFilterTmp) {
    composedCountryFilterTmp.visible = composedCountryVisible ? 1 : 2;
  }
  return inputListTmp;
};
